export function comboiosInRequest(params = {}) {
  return {
    type: '@comboio/COMBOIOS_IN_REQUEST',
    payload: { params },
  };
}

export function findComboio(idposto) {
  return {
    type: '@comboio/FIND_COMBOIO',
    payload: { idposto },
  };
}

export function failedRequest() {
  return {
    type: '@comboio/FAILED_REQUEST',
  };
}

export function deleteComboio(idposto, params) {
  return {
    type: '@comboio/DELETE_COMBOIO',
    payload: { idposto, params },
  };
}

export function updateComboio(comboio, params) {
  return {
    type: '@comboio/UPDATE_COMBOIO',
    payload: { comboio, params },
  };
}

export function storeComboio(comboio, params) {
  return {
    type: '@comboio/STORE_COMBOIO',
    payload: { comboio, params },
  };
}

export function successInRequest(
  comboios,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@comboio/SUCCESS_IN_REQUEST',
    payload: { comboios, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(comboio) {
  return {
    type: '@comboio/SUCCESS_REQUEST',
    payload: { comboio },
  };
}

export function successRemove(params) {
  return {
    type: '@comboio/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@comboio/RECORD_FILTERING',
    payload: { params },
  };
}
